<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Minimize" class="d-icon d-icon--minimize" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M10.854 1.147a.5.5 0 0 1 0 .707L8.207 4.5H10a.5.5 0 1 1 0 1H7a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 1 0v1.793l2.647-2.646a.5.5 0 0 1 .707 0Zm-9 9.707a.5.5 0 0 1-.707-.707L3.793 7.5H2a.5.5 0 0 1 0-1h3a.5.5 0 0 1 .5.5v3a.5.5 0 1 1-1 0V8.207l-2.646 2.647Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconMinimize',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
